<template>
    <div class="accordion" :id="'kt_accordion_1'+id">
        <div class="accordion-item">
            <h2 class="accordion-header" :id="'kt_accordion_1_header_1'+id">
                <button class="accordion-button fs-4 fw-bold" type="button" data-bs-toggle="collapse" :data-bs-target="'#kt_accordion_1_body_1'+id" aria-expanded="true" :aria-controls="'kt_accordion_1_body_1'+id">
                    {{$t('projects.label.lastAction') }}
                    <span class="text-success fw-bold fs-5 mx-2">{{ 
                    formatRemainingTime(new Date(history?.date ), locale) 
                    }}</span>
                </button>
            </h2>
            
            <div :id="'kt_accordion_1_body_1'+id" class="accordion-collapse collapse" aria-labelledby="kt_accordion_1_header_1" data-bs-parent="#kt_accordion_1">
                <div  class="accordion-body mt-4">
                    <div class=" min-h-60px bg-light rounded p-5">
                        <h5 class="text-warning mb-2">{{history?.user?.lastname + ' ' +history?.user?.firstname }}</h5>
                        <div class="text-black fs-5 mb-2" v-if="history?.action">{{ history?.action[locale]}}</div>
                    </div>
                    
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
import { useLocales } from '@/composables/locales';
import { formatRemainingTime } from '@/mixins/Helpers';

const {locale} = useLocales()
const props = defineProps({
    id:{type: String, default:"folder"},
    history:{type: Object, default:{}}
})
</script>
<style scoped>

.accordion-item{
    border: 0px !important;
}

.accordion-button:not(.collapsed) {
    color: #000 !important;
    background-color: #fff !important;
    box-shadow: inset 0 -1px 0 #fff;
}

.accordion-button{
    padding: 0px !important;
}

button:not(.collapsed)::after {
    background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23000000'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e") !important;
    transform: rotate(-180deg) !important;
}

.accordion-body{
    padding: 0px !important;
}

</style>